import { Row } from "antd";

const SectionHeader = ({ title, description, extra, ...props }) => {
  return (
    <Row style={{ width: "100%", marginBottom: "1rem" }} {...props}>
      <h2 style={{ width: "100%", fontSize: "1.25rem", fontWeight: "bold", margin: "1.5rem 0 0.5rem 0" }}>{title}</h2>
      {description ? (
        <p style={{ width: "100%", color: "#666", margin: "0 0 0.5rem 0" }}>
          {description} {extra}
        </p>
      ) : null}
    </Row>
  );
};

export default SectionHeader;
